import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultPlaceholderDirective } from '@shared/directives/default-placeholder.directive';
import { Base64ImagePipe } from '@shared/pipes/base64-image.pipe';
@Component({
  selector: 'app-something-wrong-dialog',
  templateUrl: './something-wrong-dialog.component.html',
  imports: [TranslateModule, DefaultPlaceholderDirective, Base64ImagePipe],
})
export class SomethingWrongDialogComponent {
  @Input() error: HttpErrorResponse;
  @Input() title = 'UI.SomethingWrong.Title';
  @Input() message = 'UI.SomethingWrong.Message';
  @Input() okText = 'OK';
  @ViewChild('modalRef') modalRef: ElementRef;

  constructor(public activeModal: NgbActiveModal) {}
}
